import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/emergency-fund',
  component: () => import('../../routes/EmergencyFund.svelte'),
  card: {
    id: 'emergency-fund',
    title: 'Emergency Fund',
    description: 'Calculate how much you need in your emergency fund based on expenses, dependents, and job stability.',
    icon: 'shield',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/emergency-fund',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Emergency Fund Calculator – How Much Emergency Savings Do You Need?',
    description: 'Free emergency fund calculator based on monthly expenses, dependents, and job stability. Calculate your recommended emergency fund target, track savings progress, and see how long it takes to build your financial safety net.',
  },
};

export default meta;
